import '../Scss/styles.scss';
import Events from './Website/Events';

document.addEventListener('DOMContentLoaded', Events.DOMContentLoadedEvents);

// kb:*:loaded is triggered from within react code when the knowledge base content is loaded **
document.addEventListener('kb:content:loaded', Events.KnowledgeBaseLoadedEvents);
document.addEventListener('kb:faq:loaded', Events.KnowledgeBaseLoadedEvents);

document.addEventListener('zdsNavigationBodyOpened', Events.zdsNavigationBodyOpenedEvents);
window.addEventListener('load', Events.loadEvents);

// Some general scripts
// TODO: rewrite to not use jQuery?
// Prevent scrolling the underlying page when the cookie banner modal is open
jQuery(document).on('click', '.cookie-notice .cn-learn-more', function () {
    document.documentElement.dataset.modalActive = true;
});
jQuery(document).on(
    'click',
    '.cookie-modal div.cm-bg, button.cm-btn-accept-all, .cookie-modal button.hide, button.cm-btn-accept',
    function () {
        document.documentElement.dataset.modalActive = false;
    },
);

// Clear browser session storage when URL has GET parameter 'logout' or 'login'
if (location.search.indexOf('logout') >= 0 || location.search.indexOf('login') >= 0) {
    sessionStorage.clear();
}

const closeMenu = (animate = true) => {
    document.getElementById('main-menu')?.getElementsByTagName('zds-navigation')?.[0]?.closeBody(animate);
};

// Close the window when navigating to the next page, this prevents the menu from being open when navigating back
window.addEventListener('unload', (event) => {
    closeMenu(false);
});

// Safari has some quirks where it always loads the page from the back-forward cache, so check for that and close the menu when coming back from the bfcache
window.onpageshow = (event) => {
    if (event.persisted) {
        closeMenu(false);
    }
};

// Close the menu when hash changes, this happens for example when clicking on a knowledgebase item in the search results
window.addEventListener(
    'hashchange',
    () => {
        closeMenu();
    },
    false,
);

// For some YouTube videos the maxresdefault thumbnail is not available.
// In this case we use the lower resolution thumbnail (mqdefault) that is always available.
//
// Unfortunately YouTube sends a 404 http status code, but also a base64 fallback image
// therefore we can not use the onerror callback from the img tag...
// The only way to detect that the thumbnail is not available,
// is to compare the naturalWidth and naturalHeight against the fallback image dimensions from YouTube
window.fixMissingYouTubeThumbnail = (youtubeThumbnail) => {
    if (
        youtubeThumbnail.naturalWidth == 120 &&
        youtubeThumbnail.naturalHeight == 90 &&
        !youtubeThumbnail.src.includes('mqdefault')
    ) {
        const newSrc = youtubeThumbnail.src.replace('maxresdefault', 'mqdefault');
        youtubeThumbnail.src = newSrc;
        youtubeThumbnail.parentNode.children[0].srcset = newSrc;
    }
};

// YouTube DCE - Replace static image with iFrame when user clicks on play
window.youtubeInit = (videoContainer) => {
    if (videoContainer.classList.contains('activated')) {
        return;
    }

    videoContainer.classList.add('activated');
    const lazyLoadingChild = videoContainer.querySelector('.youtube__lazy-loading-content');
    videoContainer.removeChild(lazyLoadingChild);

    const iFrame = document.createElement('iframe');
    iFrame.classList.add('youtube__iframe');
    iFrame.allow = 'autoplay; fullscreen';
    iFrame.src = videoContainer.getAttribute('data-video-url');

    videoContainer.appendChild(iFrame);
};
